import React,{useEffect,useState,useCallback,useRef} from 'react'
import { connect } from "react-redux"
import {getContentPath}  from './AssetManager'
import Globals from './Globals'
import {fetchNarrativeGroups,fetchNarratives,fetchThemes} from "./AssetManager"
import {setInitialized, setNarrativeTree, setNarratives, setThemes, setUser} from 'store/actions'
import history from './navigation/MainRouterHistory'
import axios from 'axios'
import Cookies from 'js-cookie';
import LoaderWheel from './components/LoaderWheel'



const  Launch = (props)=>{
    
    const [status, setStatus] = useState('Starting');
    // const [themesLoaded, setThemesLoaded] = useState(false);
    const deviceSnRef = useRef();
    
    function loadFontList(){
        return new Promise( (resolve,reject)=>{
            
            
            // axios.get(getContentPath('core/fonts/fonts.css?d=1')).then((response)=>{
                let eleStyle =document.querySelector("#fontdefinitions")
                if(eleStyle)eleStyle.remove()
                var fileref=document.createElement('link')
                fileref.setAttribute('rel', 'stylesheet')
                fileref.setAttribute('type', 'text/css')
                // fileref.innerHTML=response.data
                fileref.setAttribute('href', getContentPath('core/fonts/fonts.css'))
                document.getElementsByTagName('head')[0].appendChild(fileref);

                

                resolve()
            // }).catch( error =>{
            //     console.error(error)
            //     reject(error)
            // })
        })
    }


// In browsers that don’t yet support this functionality,
// playPromise won’t be defined.

    const onThemesLoaded =  useCallback(async  ()=>{

        // setStatus('Loading Themes')
        
        let res= null
        let resNarratives;
        let resGroups;

        await loadFontList()
         try{
            resNarratives = await fetchNarratives()
            console.log('%c resNarratives', 'font-weight:bold', resNarratives)
            }catch(err){
                Globals.instance().showAlert('Access Error','Could not load narratives. Your access token may be invalid.')
            }

        if(resNarratives) props.setNarratives(resNarratives)
    
        // setStatus('Narrative Tree')

        try{
         resGroups = await fetchNarrativeGroups()
        }catch(err){
            Globals.instance().showAlert('Could not fetch narrative groups')
        }
        props.setNarrativeTree(resGroups);
        
        props.setInitialized(true)
        // setStatus('Welcome')
        
        // if(props.user)
        // setStatus('Welcome Back '+props.user.username)
        setTimeout(()=>{
            // console.log("REDIRECT")
            if(props.location && props.location.state && props.location.state.referrer)
            {
                let path = props.location.state.referrer.pathname
                let search = props.location.state.referrer.search
                console.log("referrer ... " + path)

                if (Globals.instance().electron) {
                    Globals.instance().appPath = props.location.state.referrer.pathname.replace('/index.html','');
                } else if (Globals.instance().ios) {
                    // NEED TO FIX THIS
                    // Globals.instance().appPath = ""
                } else {
                    Globals.instance().appPath = ""
                }

                
                console.log('appPath', Globals.instance().appPath,  props.location.state.referrer.pathname)
                
                history.replace({pathname:Globals.instance().getRoute(path),search:search})

            }
            else if(props.location && props.location.hash.indexOf('#/redirect')===0)
            {   
                // console.log("redirect")
                let path = props.location.hash.replace('#/redirect','')
                history.replace(Globals.instance().getRoute(path))
            }
            else{
                history.replace({ pathname: '/home' })
            }

        },Globals.instance.iosOverlay === true ? 0 : 1000)
       
    },[props])

    async function getUserRestrictions(username){
       
        return new Promise((resolve,reject)=>{
            axios.get(Globals.instance().adminAPI+'/api/core/user-restrictions/'+username).then(response=>{
                resolve([response.data.narratives, response.data.market, response.data.category, response.data.device_sn, response.data.link_token, response.data.org, response.data.default_aspectratio, response.data.letterbox, response.data.default_devicesize, response.data.display_ip])
                // console.log("getUserRestrict", [response.data.narratives, response.data.market, response.data.category, response.data.device_sn, response.data.link_token, response.data.org])
            }).catch(err=>{reject(err)})
        })
    }
    async function verifyToken(token){
        // If no internet, automatically verify the token
        if (Globals.instance().noInternet === true) {
            console.log("No internet - bypassing token verification")
            return Promise.resolve('success')
        }
        
        return new Promise((resolve,reject)=>{
            axios({
                method: 'get',
                baseURL: Globals.instance().adminOriginAPI,
                url: 'auth/users/me/',
                headers: {  Authorization: 'Token ' + token }
                })
                .then(response => {  resolve(response.status===200?'success':'failure')  }).catch(function (error) {
                    console.error(error)    
                    if (error.response) {
                        console.log("not verified ")
                        reject(error)
                    } else if (error.request) {
                        console.log("could not hear from server")
                        resolve('resolve not verified')
                      } else {
                          reject(error)
                      }

                    reject(error)
                })
        })
    }


    useEffect(() => {
        if (props.user){
            let cancelSignal = axios.CancelToken.source();
            const getThemes = async () =>{
                try{ 
                    await props.setThemes(await fetchThemes(cancelSignal)) 
                
                }catch(err){
                    console.log(err)    
                    // Globals.instance().showAlert('Could not load themes')
                }
                onThemesLoaded()
            }
            getThemes();
        } 
    }, [props.user])

    
    useEffect(()  => { 

       
        const onMount = async () =>{
            let cancelSignal = axios.CancelToken.source();
            //  // Check for internet connection
            // let isOffline;
            // let mode=localStorage.getItem('offlineMode')
    
            // if (!navigator.onLine || mode === 'true') {
            //     isOffline = true
            // } else {
            //     isOffline = false
            // }

            // Globals.instance().offlineMode = isOffline;
            // console.log('offlineMode', Globals.instance().offlineMode, mode)

            if (Globals.instance().offlineMode) {
                Globals.instance().useCMS = false;
                Globals.instance().useLocal = true;
            }

             if (Globals.instance().electron) {
                if (props.location && props.location.state && props.location.state.referrer) {
                    Globals.instance().appPath = props.location.state.referrer.pathname.replace('/index.html','');
                    console.log('appPath', Globals.instance().appPath,  props.location.state.referrer.pathname)
                } else {
                    // Try to get path from current window location as fallback
                    const currentPath = window.location.pathname.replace('/index.html', '');
                    Globals.instance().appPath = currentPath;
                    console.warn('Electron app missing referrer data, using current path:', currentPath);
                }
            } else if (Globals.instance().ios) {
                // NEED TO FIX THIS
                // Globals.instance().appPath = ""
            } else {
                Globals.instance().appPath = ""
            }

            


            let showDownload = localStorage.getItem('expo.downloadAlert')
            let downloaded = localStorage.getItem('expo.downloaded')
            // console.log('Globals.instance.downloadAlerts', Globals.instance().downloadAlerts)
            if ((!showDownload || showDownload.length === 0) && !Globals.instance().downloadAlerts) {
                let list = JSON.stringify([]);
                localStorage.setItem('expo.downloadAlert', list)
            }

            if (downloaded) {

                Globals.instance().downloaded = downloaded

            
            }


            console.log('MOUNT')
            setStatus('Starting up')
            Globals.instance().nid=null
            
            let strUser = localStorage.getItem('user')
            // console.log('strUser', strUser)
            let narrativeId;
            let narrativeToken;
            if (props && props.location.state && props.location.state.referrer) {
                let params = new URLSearchParams(props.location.state.referrer.search)
                narrativeToken = params.get('u');
                let pathname = props.location.state.referrer.pathname
                let pathSplit = pathname.split('/narrative/');
                if (pathSplit.length > 0) {narrativeId = pathSplit[1]}
            } 
           
            if (narrativeToken && narrativeId) {
                setStatus('Verifying user from token')
             
                axios({
                    method: 'post',
                    baseURL: Globals.instance().adminOriginAPI,
                    url: 'api/core/verify-narrative-token/',
                    data: {
                        "link_token": narrativeToken,
                        "narrative_id": narrativeId
                    }
                    })
                    .then(response => {
                        let userObj = {}
                        userObj.narratives = [parseInt(narrativeId)]
                        userObj.market= null
                        userObj.category= "anon"
                        userObj.device_sn = null
                        userObj.link_token = narrativeToken
                        userObj.token = narrativeToken
                        console.log('linkToken userObj', userObj)
                        props.setUser(userObj)
                    }).catch(function (error) {
                        console.error(error.response)
                        setStatus('')
                        const redirectToLogin = () => {
                            window.removeEventListener('close-alert', redirectToLogin)
                            history.replace('/login')
                        }
                        window.addEventListener('close-alert', redirectToLogin)
                        if (error.response && error.response.status === 401) {
                            Globals.instance().showAlert('Access Denied', 'This access link is no longer valid.')
                        } else {
                            Globals.instance().showAlert('Access Denied', 'Could not verify access to this narrative.')
                        }
                    })
    
            } else {

                let userObj=JSON.parse(strUser)

                console.log("userObj at Launch", userObj, Globals.instance().offlineMode)
                if (Globals.instance().noInternet) {
                    props.setUser(userObj);
                } else {
                      if(userObj){
                        setStatus('Verifying user')
                        try{
                            let resVerify = await verifyToken(userObj.token,cancelSignal)
                            // setStatus('checking restrictions')
                            if(resVerify!=='resolve not verified')

                            var userObjArray = await getUserRestrictions(userObj.username)
                            if (userObjArray) {
                                // console.log('userObjArray', userObjArray)
                                userObj.narratives= userObjArray[0]
                                userObj.market= userObjArray[1]
                                userObj.category= userObjArray[2]
                                userObj.device_sn = userObjArray[3]
                                userObj.link_token = userObjArray[4]
                                userObj.default_aspectratio = userObjArray[6]
                                userObj.letterbox = userObjArray[7]
                                userObj.default_devicesize = userObjArray[8]
                                userObj.display_ip = userObjArray[9]
                                if (userObj.default_devicesize && userObj.default_devicesize.length > 1) {
                                    Globals.instance().device_width = userObj.default_devicesize[0]
                                    Globals.instance().device_height = userObj.default_devicesize[1]
                                }
                                    
                                // userObj.default_aspectratio && Globals.instance() && !Globals.instance().electron
                                if (userObj.default_aspectratio && userObj.letterbox) {
                                    let root = document.getElementById('main');
                        
                                    if (window.innerWidth > 1366) {
                                        root.dataset.aspect = userObj.default_aspectratio
                                        root.style.aspectRatio = userObj.default_aspectratio
                                        root.classList.add('letterBoxed')
                                        Globals.instance().aspect_ratio = parseFloat(userObj.default_aspectratio)
                                    } else {
                                        console.log('navigator.maxTouchPoints', navigator.maxTouchPoints)
                                        if (navigator.maxTouchPoints > 0) {
                                            root.classList.add('touchDevice')
                                        }
                                        
                                    }
                                    
                                    // console.log('Globals.instance().aspect_ratio', Globals.instance().aspect_ratio)
                                }

                                console.log('userObjArray', userObjArray)
                                if (userObjArray[5]) {
                                    userObj.org_logo = userObjArray[5]['logo']
                                    userObj.org_name = userObjArray[5]['name']
                                }
                                
                            }
                            console.log('signed in userObj', userObj)
                            props.setUser(userObj);
                        
                        }catch(err){
                            console.log('user not verified - 1',userObj)
                            props.setUser(null)
                            Cookies.remove('_expo_tokenid')
                            if (!Globals.instance().controllerApp && ((Globals.instance().ios || Globals.instance().electron) && !Globals.instance().offlineMode)) {
                                console.log('redirect to login 1.0')
                                history.replace({ pathname: '/login' })
                            }
                            if (!((Globals.instance().ios || Globals.instance().electron))) {
                                console.log('redirect to login 1.1')
                                history.replace({ pathname: '/login' })
                            }

                        }
                    
                    } else {
                        console.log('user not verified - 2', userObj, ((Globals.instance().ios || Globals.instance().electron) && !Globals.instance().offlineMode), Globals.instance().controllerApp)
                        if (!Globals.instance().controllerApp && ((Globals.instance().ios || Globals.instance().electron) && !Globals.instance().offlineMode)) {
                            console.log('redirect to login 2.0')
                            history.replace({ pathname: '/login' })
                        }
                        if (!((Globals.instance().ios || Globals.instance().electron))) {
                        
                        
                            if (!Globals.instance().controllerApp) {
                                console.log('redirect to login 2.1')
                                history.replace({ pathname: '/login' })
                            }
                        
                        }

                    }
                }
              
            }

            
        }

        async function checkUserCookie() {
            var cookie = Cookies.get('_expo_tokenid');
            var user = localStorage.getItem('user');
            console.log('Checking user cookie', cookie, user);
            if (cookie && cookie.length > 0 && (!user || user.length === 0)) {
                try {
                    const response = await axios({
                        method: 'get',
                        baseURL: Globals.instance().adminOriginAPI,
                        url: '/auth/users/me/',
                        headers: {
                            Authorization: 'Token ' + cookie
                        }
                    });
                    
                    console.log('User cookie validated', response.data);
                    if (response.data['username']) {
                        try {
                            const userObjArray = await getUserRestrictions(response.data['username']);
                            let userObj = {};
                            userObj.token = cookie;
                            userObj.username = response.data['username'];
                            userObj.type = 'user';
                            userObj.narratives = userObjArray[0];
                            userObj.market = userObjArray[1];
                            userObj.category = userObjArray[2];
                            userObj.device_sn = userObjArray[3];
                            userObj.link_token = userObjArray[4];
                            userObj.org = userObjArray[5];
                            userObj.default_aspectratio = userObjArray[6];
                            userObj.letterbox = userObjArray[7];
                            userObj.default_devicesize = userObjArray[8];
                            userObj.display_ip = userObjArray[9];
                            if (userObj.default_devicesize && userObj.default_devicesize.length > 1) {
                                Globals.instance().device_width = userObj.default_devicesize[0]
                                Globals.instance().device_height = userObj.default_devicesize[1]
                            }
                            props.setUser(userObj);
                            console.log('Signed in userObj from cookie', userObj);
                        } catch (err) {
                            console.error('Could not get user restrictions', err);
                            if (!Globals.instance().controllerApp) {
                                // history.replace({ pathname: '/login' })
                            }
                        }
                    } else {
                        console.error('Could not get user restrictions 2');
                        if (!Globals.instance().controllerApp) {
                            // history.replace({ pathname: '/login' })
                        }
                    }
                } catch (error) {
                    console.log('Error validating user cookie', error);
                }
            } else {
                console.log('No user cookie found');
                if ((Globals.instance().offlineMode) && (!user || user.length === 0)) {
                   history.replace({ pathname: '/login' })
                } 

                return true;
                
            }
        }
        const initializeApp = async () => {
            // Check internet connectivity first and wait for it to resolve
            try {
                console.log('Checking internet connectivity...');
                await Globals.instance().checkInternetConnectivity();
                console.log('Internet connectivity check completed', Globals.instance().offlineMode, Globals.instance().noInternet);
            } catch (error) {
                console.error('Error checking internet connectivity:', error);
                // Continue with initialization even if connectivity check fails
            }
            
            if (!Globals.instance().offlineMode && !Globals.instance().noInternet) {
                await checkUserCookie()
            }
            await onMount()
            

        }


        initializeApp()

        
  
    
        return ()=>{
            console.log("LEFT LAUNCH")
            // cancelSignal.cancel('stopping launch')
            // await props.setThemes(await fetchThemes(cancelSignal)) 
               
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return( 
        <div className={`fullscreen fcenter loadingPage`} >
                <div className={`fullscreen fcenter`} >
                    <LoaderWheel status={status}></LoaderWheel>
                </div>
        </div>
    )
        
}


function mapDispatchToProps(dispatch) {    
    return {
        setInitialized: val => dispatch(setInitialized(val)),
        setNarrativeTree: tree => dispatch(setNarrativeTree(tree)),
        setNarratives: narratives => dispatch(setNarratives(narratives)),
        setThemes: themes => dispatch(setThemes(themes)),
        setUser: val => dispatch(setUser(val))
    };
  }
  

  const mapStateToProps = state => {
    const {themes,user} = state
    return {themes,user};
};
  
  export default connect(mapStateToProps, mapDispatchToProps)(Launch)


